import { render, staticRenderFns } from "./CommonRatingPieNew.vue?vue&type=template&id=1cecfd3a"
import script from "./CommonRatingPieNew.vue?vue&type=script&lang=js"
export * from "./CommonRatingPieNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports